import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    orgUnits: [],
    loaded: false
  }
};
const orgUnitsSlice = createSlice({
  name: "orgUnits",
  initialState,
  reducers: {
    loadOrgUnits: (state, action) => {
      state.value = {
        orgUnits: action.payload,
        loaded: true
      };
    }
  }
});
export const { loadOrgUnits } = orgUnitsSlice.actions;
export default orgUnitsSlice.reducer;
